export const branchInfo = (state = {}, action) => {
  switch (action.type) {
    case 'SAVE_BRANCH_INFO':
      return action.data;
    default:
      return state;
  }
};
